import { render, staticRenderFns } from "./ToeflTimeManagerComponent.vue?vue&type=template&id=beb7ac22&scoped=true&"
import script from "./ToeflTimeManagerComponent.vue?vue&type=script&lang=js&"
export * from "./ToeflTimeManagerComponent.vue?vue&type=script&lang=js&"
import style0 from "./ToeflTimeManagerComponent.vue?vue&type=style&index=0&id=beb7ac22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb7ac22",
  null
  
)

export default component.exports